import axios from '../Api/api';

export default function aboutUs() {
    return new Promise((resolve, reject) => {
        axios.get("home/getAboutUs", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
